export default __webpack_public_path__ + "static/media/pantry1-afterH-480w.6d85b08b.png";